import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { useFirestore } from './useFirestore';
import { saveChannelsLocally } from '../utils/localStorageUtils';
import logger from '../utils/logger';

/**
 * Hook for auto-saving playlists
 * - For authenticated users: saves to Firestore
 * - For non-authenticated users: saves to local storage
 */
export const usePlaylistAutoSave = () => {
  const { channels } = useSelector((state: RootState) => state.playlist);
  const { user } = useSelector((state: RootState) => state.auth);
  const { savePlaylist } = useFirestore();

  const autoSave = useCallback(async () => {
    try {
      // For authenticated users: save to Firestore
      if (user?.uid) {
        logger.debug('Auto-save to Firestore started', { channelsCount: channels.length });
        await savePlaylist(user.uid, channels);
        logger.debug('Auto-save to Firestore completed successfully');
      } 
      // For non-authenticated users: save to local storage
      else {
        logger.debug('Auto-save to local storage started', { channelsCount: channels.length });
        saveChannelsLocally(channels);
        logger.debug('Auto-save to local storage completed successfully');
      }
    } catch (error) {
      logger.error('Auto-save failed:', error);
      throw error;
    }
  }, [channels, user, savePlaylist]);

  return { autoSave };
}; 